// Functions that handle inputs managed by the main div holding the whole page.
// Lets us twist the ingredients with spacebar with any focus.
// Also lets us use custom behavior for clicking on the background.

// my imports:
import Nav from "@/app/lib/input/nav";
import UI from "@/app/lib/ui/ui";
import { AnyGameObj } from "@/app/lib/game-state/game-types";

export default class PageInputs {
    game: AnyGameObj
    ui: UI;

    constructor(game: AnyGameObj, ui: UI) {
        this.game = game;
        this.ui = ui;
    }

    handleShuffle(e: React.KeyboardEvent) {
        if (this.game.state.freezeInputs())
            return;

        if (e.key !== ' ')
            return;
        
        e.preventDefault();
        e.stopPropagation();
        this.game.update(gameState => gameState.shuffle());
    }

    handleClick() {
        if (this.game.state.freezeInputs())
            return;

        // start a nav at any position
        const nav = new Nav(0, 0, this.game.state);
        const earliestEmptySlot = nav.findEarliestEmptySlot();
        
        if (!earliestEmptySlot)
            return;
        
        this.ui.focus(earliestEmptySlot);
    }

    
    isLetterBoxFocused(): boolean {
        const focused = document.activeElement;
        if (!(focused instanceof HTMLElement)) {
            return false;
        }

        const wordIndex: number = Number(focused.dataset.wordIndex);
        const letterPosition: number = Number(focused.dataset.letterPosition);

        // if data is not well-formed then we're not on a letterbox
        if (
            Number.isNaN(wordIndex)
            || Number.isNaN(letterPosition)
        ) {
            return false;
        }

        return true;
    }
}

export function handlePageShuffle(
    e: React.KeyboardEvent, 
    game: AnyGameObj
) {
        if (e.key !== ' ')
            return;
        
        e.preventDefault();
        e.stopPropagation();
        game.update(gameState => gameState.shuffle());
    }